import { MAP_CONFIG } from '../configs.js'
import { getCurrentPositionWithFallback as getCurrentPosition } from '../../utils/locationUtils.js'

export class NominatimUtils {
  static async getCurrentAddress(position) {
    if (!position) position = await getCurrentPosition()
    const url = `${MAP_CONFIG.nominatimUrl}?lat=${position.lat}&lon=${position.lng}&format=json`
    const res = await fetch(url)
    if (!res.ok) throw new Error('Erreur Nominatim')
    const data = await res.json()
    return data.display_name || null
  }
}
